// Base WLOM exception class
export class WLOMException extends Error {}

export class LocationOOBException extends WLOMException {
  constructor() {
    super('Location is out of bounds');
  }
}

export class LocationFetchError extends WLOMException {
  constructor() {
    super('Error fetching location');
  }
}
